export default "__VITE_ASSET__D39Uo3xM__"